import React, { useState, useEffect } from 'react'
import { LuPlus } from 'react-icons/lu';
import { HiMiniMinus } from "react-icons/hi2";
import { useAudio, AUDIO } from '@/app/providers/AudioProvider';


const InputFFXIV = ({
    value,
    onChange,
    min = 1,
    max = 200,
    step = 1,
    className = '',
    disabled = false
}: {
    value: number | string;
    onChange: (value: number) => void;
    min: number;
    max: number;
    step?: number;
    className?: string;
    disabled?: boolean;
}) => {
    const [inputValue, setInputValue] = useState(typeof value === 'number' ? value.toString() : value);
    const { play } = useAudio();

    useEffect(() => {
        setInputValue(typeof value === 'number' ? value.toString() : value);
    }, [value]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
    };

    const handleBlur = () => {
        if (inputValue === '') {
            const newValue = min;
            setInputValue(newValue.toString());
            onChange(newValue);
        } else {
            let val = parseInt(inputValue) || min;
            if (val < min) val = min;
            if (val > max) val = max;
            setInputValue(val.toString());
            onChange(val);
        }
    };

    const handleIncrement = () => {
        if (disabled) return;
        const currentVal = parseInt(inputValue) || min;
        const newVal = Math.min(currentVal + step, max);
        setInputValue(newVal.toString());
        onChange(newVal);
    };

    const handleDecrement = () => {
        if (disabled) return;
        const currentVal = parseInt(inputValue) || min;
        const newVal = Math.max(currentVal - step, min);
        setInputValue(newVal.toString());
        onChange(newVal);
    };

    const currentNumValue = parseInt(inputValue) || min;
    const isAtMax = currentNumValue >= max || disabled;
    const isAtMin = currentNumValue <= min || disabled;

    const [incrementActive, setIncrementActive] = useState(false);
    const [decrementActive, setDecrementActive] = useState(false);

    const handleIncrementClick = () => {
        if (isAtMax) return;
        play(AUDIO.CLICK);
        setIncrementActive(true);
        setTimeout(() => setIncrementActive(false), 50);
        handleIncrement();
    };

    const handleDecrementClick = () => {
        if (isAtMin) return;
        play(AUDIO.CLICK);
        setDecrementActive(true);
        setTimeout(() => setDecrementActive(false), 50);
        handleDecrement();
    };

    return (
        <div className="flex gap-0.5 items-center">
            <div className={`relative rounded-md ${className}`}>
                <input
                    type="number"
                    min={min}
                    max={max}
                    value={inputValue}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    step={step}
                    disabled={disabled}
                    className="w-full bg-[#4B4B4B] text-white text-[20px] leading-[0px] px-2 py-0.5 rounded-md shadow shadow-black/30 text-right cursor-text outline-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-outer-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-inner-spin-button]:m-0 [&]:-moz-appearance-textfield"
                />
                <div className="absolute top-0 left-0 h-full w-full border-t-2 border-[#5F5F5F] rounded-md pointer-events-none"></div>
            </div>
            <div 
                className={`w-7 h-7 rounded shadow shadow-black/80 flex items-center justify-center transition-all duration-[0.05] ${isAtMax ? 'bg-[#252525] text-[#141414] cursor-not-allowed' : 'bg-[#4C4C4C] text-[#242424] cursor-pointer'} ${incrementActive && !isAtMax ? 'brightness-150 scale-95' : ''}`}
                onMouseEnter={() => !isAtMax && play(AUDIO.HOVER)}
                onClick={handleIncrementClick}
            >
                <LuPlus className="text-3xl" />
            </div>
            <div 
                className={`w-7 h-7 rounded shadow shadow-black/80 flex items-center justify-center transition-all duration-[0.05] ${isAtMin ? 'bg-[#252525] text-[#141414] cursor-not-allowed' : 'bg-[#4C4C4C] text-[#242424] cursor-pointer'} ${decrementActive && !isAtMin ? 'brightness-150 scale-95' : ''}`}
                onMouseEnter={() => !isAtMin && play(AUDIO.HOVER)}
                onClick={handleDecrementClick}
            >
                <HiMiniMinus className="text-3xl" />
            </div>
        </div>
    )
}

export default InputFFXIV